import React from 'react';
import clsx from 'clsx';

export default class OwnerDetailPresenterGeneral extends React.Component {
    render() {
        var tabClasses = clsx({
            'active': this.props.active_tab == 'general',
            'tab-pane': true
        });
        return (
            <div className={tabClasses} id="general">
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{I18n.t('first_name')}</label>
                            <br />
                            <div className="form-control-static">
                                {this.props.owner_detail.first_name}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{I18n.t('last_name')}</label>
                            <br />
                            <div className="form-control-static">
                                {this.props.owner_detail.last_name}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{I18n.t('address')}</label>
                            <br />
                            <div className="form-control-static">
                                {this.props.owner_detail.address}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{I18n.t('phone')}</label>
                            <br />
                            <div className="form-control-static">
                                {this.props.owner_detail.phone}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>{I18n.t('email')}</label>
                            <br />
                            <div className="form-control-static">
                                {this.props.owner_detail.email}
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-md-6">
                        <div className="form-group">
                            <label>{I18n.t('percentage_of_ownership')}</label>
                            <br />
                            <div className="form-control-static">
                                {this.props.owner_detail.percentage_of_ownership && Number(this.props.owner_detail.percentage_of_ownership).toFixed(2) * 100 + '%'}
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            
        );
    }
}

